import React, {  useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import NewTr from "../common/table/newTr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import Select from "../common/form/select";
import Button from "../common/button/button";
import Form from "./clienteForm";
import UcForm from "./unidadeConsumidoraForm";
import Anexo from "./clienteAnexo";
import AnexoForm from "./clienteAnexoForm";

import { getLista as getListaUsuario } from "../usuario/usuarioActions";

import {
    setModoTela,
    initForm,
    salvar,
    salvarUC,
    excluir,
    excluirUC,
    reativar,
    getLista,
    getListaCidade,
    getListaConcessionaria,
    getListaConcessionariaAgua,
    getListaPlataformaMercadoLivre,
    getListaGrupoFaturamento,
    getListaSubgrupoFaturamento,
    getListaModalidadeTarifaria,
    getListaTipoMercado,
    getListaModalidadeMercadoLivre,
    getListaTipoEnergiaMercadoLivre,
    getListaTipoMedicao,
    initFormAnexo,
    salvarAnexo,
    excluirAnexo,
    getListaTipoTransformador,
} from "./clienteActions";

import { Loading } from "../common/loading/loading";
import { getLista as getListaTributacao, getlistaEstado, getListaAtividade } from "../tributacao/tributacaoActions";
import { getListaSelect as getListaEmpresa } from "../empresa/empresaActions";
import { getGestorConcessionariaSelect } from "../gestorConcessionaria/gestorConcessionariaActions";

function Cliente(props) {
    //Sem acesso
    if (!props.usuarioLogado || props.usuarioLogado.acesso_cliente) {
        return <div />;
    }
    
    const [state, setState] = useState({
        filtro: {
            id_cliente: null,
        },
    });

    useEffect(() => {
        props.getLista();
        props.getListaCidade();
        props.getlistaEstado();
        props.getListaEmpresa();
        props.getListaUsuario();
        props.getListaAtividade();
        props.getListaTributacao();
        props.getListaTipoMedicao();
        props.getListaTipoMercado();
        props.getListaConcessionaria();
        props.getListaGrupoFaturamento();
        props.getListaTipoTransformador();
        props.getListaConcessionariaAgua();
        props.getListaModalidadeTarifaria();
        props.getListaSubgrupoFaturamento();
        props.getGestorConcessionariaSelect();
        props.getListaPlataformaMercadoLivre();
        props.getListaModalidadeMercadoLivre();
        props.getListaTipoEnergiaMercadoLivre();
    }, []);


    return (
        <div>
            {props.aguardando ? <Loading /> : null}

            {/* SE O FORMULÁRIO DE UC TIVER ABERTO OCULTA O FORMULÁRIO CLIENTE */}
            {props.modoTelaUC ? (
                <Content>
                    {props.modoTelaUC === "visualizacaoUC" ? <UcForm visualizar={true} /> : null}
                    {props.modoTelaUC === "editarCampoUC" ? <UcForm editarCampoUC /> : null}
                    {props.modoTelaUC === "cadastroUC" ? <UcForm onSubmit={props.salvarUC} /> : null}
                    {props.modoTelaUC === "reativarUC" ? <UcForm reativar /> : null}
                    {props.modoTelaUC === "exclusaoUC" ? <UcForm excluir /> : null}
                </Content>
            ) : (
                <Content>
                    {props.modoTela === "visualizacao" ? <Form visualizar={true} /> : null}
                    {props.modoTela === "editar_ucs" ? <Form editar_ucs={true} /> : null}
                    {props.modoTela === "cadastro" ? <Form onSubmit={props.salvar} /> : null}
                    {props.modoTela === "exclusao" ? <Form excluir={props.excluir} /> : null}
                    {props.modoTela === "reativar" ? <Form reativar={props.reativar} /> : null}
                    {props.modoTela === "lista" ? lista() : null}
                    {props.modoTela === "cadastroAnexo" ? <AnexoForm onSubmit={props.salvarAnexo} /> : null}
                    {props.modoTela === "exclusaoAnexo" ? <AnexoForm excluir={true} onSubmit={props.excluirAnexo} /> : null}
                    {props.modoTela === "listaAnexo" ? <Anexo /> : null}
                </Content>
            )}
        </div>
    );

    function lista() {
        return (
            <ContentCard>
                <ContentCardHeader>
                    <Row>
                        <Grid cols="6 6 4 2">
                            <Button
                                text="Adicionar"
                                type={"success"}
                                icon={"fa fa-plus"}
                                disabled={!props.usuarioLogado.acesso_cadastro_cliente_adicionar}
                                event={() => {
                                    const itemForm = { id_empresa: props.usuarioLogado.id_empresa };
                                    props.setModoTela("cadastro", { ...itemForm });
                                    props.initForm({ ...itemForm });
                                }}
                            />
                        </Grid>
                    </Row>
                    <Row>
                        <Grid cols="12 12 12 12" style={{ paddingTop: 10 }}>
                            {props.usuarioLogado && !props.usuarioLogado.acesso_cliente ? (
                                <Select
                                    readOnly={props.aguardando}
                                    options={props.lista.map((cliente) => ({
                                        id: cliente.id,
                                        valor: cliente.nome,
                                    }))}
                                    label="Cliente"
                                    cols="12 6 4"
                                    placeholder="Selecione o Cliente"
                                    value={state.filtro.id_cliente}
                                    onChange={(value) => {
                                        setState({
                                            ...state,
                                            filtro: { ...state.filtro, id_cliente: value },
                                        });
                                    }}
                                />
                            ) : null}
                        </Grid>
                    </Row>
                </ContentCardHeader>
                <ContentCardBody>
                    <Table responsive>
                        <THead>
                            <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"}>
                                <Th sticky colSpan={1}>
                                    Nome
                                </Th>
                                <Th sticky colSpan={1}>
                                    CPF
                                </Th>
                                <Th sticky colSpan={1}>
                                    CNPJ
                                </Th>
                                <Th sticky colSpan={1}>
                                    E-mail de Faturamento
                                </Th>
                                <Th sticky colSpan={1}>
                                    E-mail de Contato
                                </Th>
                                <Th sticky colSpan={1}>
                                    Recebe Notificação de Fatura
                                </Th>
                                <Th sticky colSpan={1}>
                                    Controla Vencimento das Faturas
                                </Th>
                            </NewTr>
                        </THead>
                        <TBody>
                            {props.lista
                                .filter((item) => (!state.filtro.id_cliente || state.filtro.id_cliente == item.id) && !item.bloquearEdicaoClienteUsuarioImplantacao)
                                .map((item) => {
                                    const temAcessoUc =
                                        props.usuarioLogado.usuario_implantacao ||
                                        props.usuarioLogado.acesso_credenciais_concessionaria_editar ||
                                        props.usuarioLogado.acesso_codigo_uc_editar ||
                                        props.usuarioLogado.acesso_unidade_consumidora_visualizar ||
                                        props.usuarioLogado.acesso_unidade_consumidora_adicionar ||
                                        props.usuarioLogado.acesso_unidade_consumidora_editar ||
                                        props.usuarioLogado.acesso_unidade_consumidora_excluir;

                                    const condicaoVisualizarCliente = props.usuarioLogado.acesso_cadastro_cliente_visualizar && !item.bloquearEdicaoClienteUsuarioImplantacao;
                                    const condicaoAnexosCliente = props.usuarioLogado.acesso_cadastro_cliente_editar && !item.bloquearEdicaoClienteUsuarioImplantacao;
                                    const condicaoEditarCliente =
                                        (temAcessoUc || props.usuarioLogado.acesso_cadastro_cliente_editar) && !item.bloquearEdicaoClienteUsuarioImplantacao;
                                    const condicaoExcluirCliente = props.usuarioLogado.acesso_cadastro_cliente_excluir && !item.bloquearEdicaoClienteUsuarioImplantacao;

                                    const objForm = JSON.parse(JSON.stringify(item)); //clona o objeto
                                    const botoes = [
                                        {
                                            type: "primary",
                                            icon: "fas fa-eye",
                                            disabled: !condicaoVisualizarCliente,
                                            event: () => {
                                                props.setModoTela("visualizacao", objForm);
                                                props.initForm(objForm);
                                            },
                                        },
                                    ];

                                    if (item.ativo) {
                                        botoes.push(
                                            {
                                                type: "primary",
                                                icon: "fas fa-paperclip",
                                                disabled: !condicaoAnexosCliente,
                                                event: () => {
                                                    props.setModoTela("listaAnexo", objForm);
                                                },
                                            },
                                            {
                                                type: "warning",
                                                icon: "fas fa-pencil-alt",
                                                disabled: !condicaoEditarCliente,
                                                event: () => {
                                                    //se pode editar algo da uc ou visualizar a uc, deixa entrar pelo botao do lapis, podem os campos de cliente ficam apenas leitura
                                                    const modoTela = temAcessoUc && !props.usuarioLogado.acesso_cadastro_cliente_editar ? "editar_ucs" : "cadastro";
                                                    props.setModoTela(modoTela, objForm);
                                                    props.initForm(objForm);
                                                },
                                            },
                                            {
                                                type: "danger",
                                                icon: "fas fa-trash-alt",
                                                disabled: !condicaoExcluirCliente,
                                                event: () => {
                                                    props.setModoTela("exclusao", objForm);
                                                    props.initForm(objForm);
                                                },
                                            }
                                        );
                                    } else {
                                        botoes.push({
                                            type: "success",
                                            icon: "fas fa-power-off",
                                            disabled: !props.usuarioLogado.acesso_cadastro_cliente_editar || item.bloquearEdicaoClienteUsuarioImplantacao,
                                            event: () => {
                                                props.setModoTela("reativar", objForm);
                                                props.initForm(objForm);
                                            },
                                        });
                                    }
                                    let backgroundColorTr = "#FFFFFF";
                                    let backgroundColorTd = "#F5F5F5";
                                    if (!item.ativo) {
                                        backgroundColorTr = "#fd6565";
                                        backgroundColorTd = "#f25353";
                                    }

                                    return (
                                        <NewTr key={item.id} backgroundColorTr={backgroundColorTr} backgroundColorTd={backgroundColorTd} botoes={botoes}>
                                            <Td>
                                                {!item.ativo ? <span style={{ padding: 5, margin: 5, backgroundColor: "red", color: "#fff" }}>INATIVO</span> : ""}
                                                {item.nome}
                                            </Td>
                                            <Td minWidth={150}>{item.cpf ? item.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : ""}</Td>
                                            <Td minWidth={150}>{item.cnpj ? item.cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : ""}</Td>
                                            <Td maxWidth={300}>{item.faturamento_email}</Td>
                                            <Td maxWidth={300}>{item.email_contato}</Td>
                                            <Td>{item.recebe_notificacao_fatura ? "Sim" : "Não"}</Td>
                                            <Td>{item.controla_vencimento_fatura ? "Sim" : "Não"}</Td>
                                        </NewTr>
                                    );
                                })}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    }
}

const mapStateToProps = (state) => ({
    lista: state.cliente.lista,
    modoTela: state.cliente.modoTela,
    modoTelaUC: state.cliente.modoTelaUC,
    aguardando: state.cliente.aguardando,
    usuarioLogado: state.auth.usuarioLogado,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            salvar,
            excluir,
            reativar,
            getLista,
            initForm,
            salvarUC,
            excluirUC,
            salvarAnexo,
            setModoTela,
            excluirAnexo,
            initFormAnexo,
            getlistaEstado,
            getListaCidade,
            getListaUsuario,
            getListaEmpresa,
            getListaAtividade,
            getListaTributacao,
            getListaTipoMedicao,
            getListaTipoMercado,
            getListaConcessionaria,
            getListaGrupoFaturamento,
            getListaTipoTransformador,
            getListaConcessionariaAgua,
            getListaModalidadeTarifaria,
            getListaSubgrupoFaturamento,
            getGestorConcessionariaSelect,
            getListaPlataformaMercadoLivre,
            getListaModalidadeMercadoLivre,
            getListaTipoEnergiaMercadoLivre,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(Cliente);
